/**
 * @generated SignedSource<<a715e83d92030ec1d9638eac854e614a>>
 * @relayHash 6548f416a6391553af4df0d1b54dfe6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f6a33f32324809467e06176df58b35f17889dafe5f9de8900f7144242ed0d2d

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContentType = "ATTACHMENT" | "BLOG_POST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type useFilterSupplierAdvancedSearchFilterV3Query$variables = {
  accountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  ancestorId?: string | null | undefined;
  cloudId: string;
  eventTypes?: ReadonlyArray<string> | null | undefined;
  first?: number | null | undefined;
  hasAncestor: boolean;
  hasSpaces: boolean;
  hasUsers: boolean;
  isAnon: boolean;
  objectTypes?: ReadonlyArray<string> | null | undefined;
  spaceKeys?: ReadonlyArray<string | null | undefined> | null | undefined;
  userId: string;
};
export type useFilterSupplierAdvancedSearchFilterV3Query$data = {
  readonly activity?: {
    readonly myActivity: {
      readonly all: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly id: string;
            readonly object: {
              readonly data: {
                readonly id?: string;
                readonly title?: string | null | undefined;
                readonly type?: ConfluenceContentType | null | undefined;
              } | null | undefined;
              readonly id: string;
            };
          };
        }>;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
    } | null | undefined;
  } | null | undefined;
  readonly ancestorData?: {
    readonly id: string | null | undefined;
    readonly title: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
  readonly confluenceUsers?: {
    readonly nodes: ReadonlyArray<{
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly contentTypes: {
    readonly cqlContentTypes: ReadonlyArray<{
      readonly label: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly currentUser?: {
    readonly confluence: {
      readonly accountId: string | null | undefined;
    } | null | undefined;
    readonly displayName: string | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly getSmartFeatures?: {
    readonly results: ReadonlyArray<{
      readonly entityType: string;
      readonly result?: ReadonlyArray<{
        readonly features: {
          readonly recommendedPeople: ReadonlyArray<{
            readonly score: number;
            readonly user: {
              readonly confluence: {
                readonly accountId: string | null | undefined;
              } | null | undefined;
              readonly displayName: string | null | undefined;
              readonly id: string | null | undefined;
              readonly photos: ReadonlyArray<{
                readonly value: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly recommendedSpaces: ReadonlyArray<{
            readonly score: number;
            readonly space: {
              readonly icon: {
                readonly path: string;
              } | null | undefined;
              readonly id: string | null | undefined;
              readonly key: string | null | undefined;
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        };
        readonly id: string;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly spaces?: {
    readonly nodes: ReadonlyArray<{
      readonly icon: {
        readonly path: string;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useFilterSupplierAdvancedSearchFilterV3Query = {
  response: useFilterSupplierAdvancedSearchFilterV3Query$data;
  variables: useFilterSupplierAdvancedSearchFilterV3Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ancestorId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTypes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasAncestor"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSpaces"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUsers"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnon"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectTypes"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKeys"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v12 = {
  "kind": "ScalarField",
  "name": "type"
},
v13 = {
  "alias": "contentTypes",
  "concreteType": "Confluence_cqlMetaData",
  "kind": "LinkedField",
  "name": "cqlMetaData",
  "plural": false,
  "selections": [
    {
      "concreteType": "CQLDisplayableType",
      "kind": "LinkedField",
      "name": "cqlContentTypes",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        {
          "kind": "ScalarField",
          "name": "label"
        }
      ]
    }
  ]
},
v14 = [
  {
    "items": [
      {
        "fields": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "entityIds.0",
                "variableName": "userId"
              }
            ],
            "kind": "ListValue",
            "name": "entityIds"
          },
          {
            "kind": "Literal",
            "name": "entityType",
            "value": "user"
          },
          {
            "kind": "Literal",
            "name": "features",
            "value": [
              "recommendedSpaces",
              "recommendedPeople"
            ]
          }
        ],
        "kind": "ObjectValue",
        "name": "input.0"
      }
    ],
    "kind": "ListValue",
    "name": "input"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "entityType"
},
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "kind": "ScalarField",
  "name": "score"
},
v18 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v20 = {
  "concreteType": "ConfluenceUser",
  "kind": "LinkedField",
  "name": "confluence",
  "plural": false,
  "selections": (v19/*: any*/)
},
v21 = {
  "kind": "ScalarField",
  "name": "value"
},
v22 = [
  (v16/*: any*/),
  {
    "kind": "ScalarField",
    "name": "key"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "concreteType": "Icon",
    "kind": "LinkedField",
    "name": "icon",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "type",
            "value": "ABSOLUTE"
          }
        ],
        "kind": "ScalarField",
        "name": "path",
        "storageKey": "path(type:\"ABSOLUTE\")"
      }
    ]
  }
],
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "SmartFeaturesUserResult",
      "kind": "LinkedField",
      "name": "result",
      "plural": true,
      "selections": [
        (v16/*: any*/),
        {
          "concreteType": "SmartUserFeatures",
          "kind": "LinkedField",
          "name": "features",
          "plural": false,
          "selections": [
            {
              "concreteType": "RecommendedPeopleItem",
              "kind": "LinkedField",
              "name": "recommendedPeople",
              "plural": true,
              "selections": [
                (v17/*: any*/),
                {
                  "concreteType": "AtlassianUser",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v16/*: any*/),
                    (v18/*: any*/),
                    (v20/*: any*/),
                    {
                      "concreteType": "AtlassianUserPhoto",
                      "kind": "LinkedField",
                      "name": "photos",
                      "plural": true,
                      "selections": [
                        (v21/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "concreteType": "RecommendedSpaceItem",
              "kind": "LinkedField",
              "name": "recommendedSpaces",
              "plural": true,
              "selections": [
                (v17/*: any*/),
                {
                  "concreteType": "Space",
                  "kind": "LinkedField",
                  "name": "space",
                  "plural": false,
                  "selections": (v22/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "SmartFeaturesUserResultResponse"
},
v24 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "eventTypes",
            "variableName": "eventTypes"
          },
          {
            "kind": "Variable",
            "name": "objectTypes",
            "variableName": "objectTypes"
          },
          {
            "kind": "Literal",
            "name": "products",
            "value": [
              "CONFLUENCE"
            ]
          }
        ],
        "kind": "ObjectValue",
        "name": "arguments"
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "rootContainerIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "rootContainerIds"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": "AND"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v26 = [
  (v16/*: any*/),
  {
    "kind": "ScalarField",
    "name": "title"
  },
  (v12/*: any*/)
],
v27 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "ConfluencePage"
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "ConfluenceBlogPost"
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "ConfluenceWhiteboard"
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "ConfluenceDatabase"
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v26/*: any*/),
  "type": "ConfluenceEmbed"
},
v32 = {
  "concreteType": "ActivityPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v33 = {
  "alias": "currentUser",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    (v18/*: any*/),
    {
      "concreteType": "AtlassianUserPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        (v21/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isPrimary"
        }
      ]
    },
    (v20/*: any*/)
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v34 = {
  "condition": "hasSpaces",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "spaceKeys",
          "variableName": "spaceKeys"
        }
      ],
      "concreteType": "PaginatedSpaceList",
      "kind": "LinkedField",
      "name": "spaces",
      "plural": false,
      "selections": [
        {
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v22/*: any*/)
        }
      ]
    }
  ]
},
v35 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  }
],
v36 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v37 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "KnownUser"
},
v38 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "UnknownUser"
},
v39 = {
  "condition": "hasAncestor",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "ancestorData",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "ancestorId"
        }
      ],
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "singleContent",
      "plural": false,
      "selections": (v26/*: any*/)
    }
  ]
},
v40 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v41 = [
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useFilterSupplierAdvancedSearchFilterV3Query",
    "selections": [
      (v13/*: any*/),
      {
        "condition": "isAnon",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v14/*: any*/),
            "concreteType": "SmartFeaturesResponse",
            "kind": "LinkedField",
            "name": "getSmartFeatures",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v23/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "Activity",
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              {
                "concreteType": "MyActivity",
                "kind": "LinkedField",
                "name": "myActivity",
                "plural": false,
                "selections": [
                  {
                    "args": (v24/*: any*/),
                    "concreteType": "ActivityConnection",
                    "kind": "LinkedField",
                    "name": "all",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "concreteType": "ActivityNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "concreteType": "ActivityObject",
                                "kind": "LinkedField",
                                "name": "object",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v32/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v33/*: any*/)
        ]
      },
      (v34/*: any*/),
      {
        "condition": "hasUsers",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v35/*: any*/),
            "concreteType": "PaginatedPersonList",
            "kind": "LinkedField",
            "name": "confluenceUsers",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      (v39/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v11/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v9/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useFilterSupplierAdvancedSearchFilterV3Query",
    "selections": [
      (v13/*: any*/),
      {
        "condition": "isAnon",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v14/*: any*/),
            "concreteType": "SmartFeaturesResponse",
            "kind": "LinkedField",
            "name": "getSmartFeatures",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  (v40/*: any*/),
                  (v15/*: any*/),
                  (v23/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "Activity",
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              {
                "concreteType": "MyActivity",
                "kind": "LinkedField",
                "name": "myActivity",
                "plural": false,
                "selections": [
                  {
                    "args": (v24/*: any*/),
                    "concreteType": "ActivityConnection",
                    "kind": "LinkedField",
                    "name": "all",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "concreteType": "ActivityNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "concreteType": "ActivityObject",
                                "kind": "LinkedField",
                                "name": "object",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v40/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v41/*: any*/),
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v41/*: any*/),
                                        "type": "DevOpsPullRequestDetails"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v32/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v33/*: any*/)
        ]
      },
      (v34/*: any*/),
      {
        "condition": "hasUsers",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v35/*: any*/),
            "concreteType": "PaginatedPersonList",
            "kind": "LinkedField",
            "name": "confluenceUsers",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v40/*: any*/),
                  (v18/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      (v39/*: any*/)
    ]
  },
  "params": {
    "cacheID": "6548f416a6391553af4df0d1b54dfe6f",
    "id": "2f6a33f32324809467e06176df58b35f17889dafe5f9de8900f7144242ed0d2d",
    "metadata": {},
    "name": "useFilterSupplierAdvancedSearchFilterV3Query",
    "operationKind": "query",
    "text": "query useFilterSupplierAdvancedSearchFilterV3Query($userId:String!,$isAnon:Boolean!,$accountIds:[String],$spaceKeys:[String],$ancestorId:ID,$hasUsers:Boolean!,$hasSpaces:Boolean!,$hasAncestor:Boolean!,$cloudId:ID!,$objectTypes:[String!],$eventTypes:[String!],$first:Int){getSmartFeatures(input:[{entityType:\"user\",entityIds:[$userId],features:[\"recommendedSpaces\",\"recommendedPeople\"]}])@skip(if:$isAnon){results{__typename,entityType,...on SmartFeaturesUserResultResponse{entityType,result{id,features{recommendedPeople{score,user{id,displayName,confluence{accountId},photos{value}}},recommendedSpaces{score,space{id,key,name,icon{path(type:ABSOLUTE)}}}}}}}}\n  activity@skip(if:$isAnon){myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type},...on ConfluenceBlogPost{id,title,type},...on ConfluenceWhiteboard{id,title,type},...on ConfluenceDatabase{id,title,type},...on ConfluenceEmbed{id,title,type},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id}}}}},pageInfo{hasNextPage}}}}\n  currentUser:confluence_atlassianUser(current:true)@skip(if:$isAnon){id,displayName,photos{value,isPrimary},confluence{accountId}},spaces(spaceKeys:$spaceKeys)@include(if:$hasSpaces){nodes{id,key,name,icon{path(type:ABSOLUTE)}}},confluenceUsers(accountIds:$accountIds)@include(if:$hasUsers){nodes{__typename,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},contentTypes:cqlMetaData{cqlContentTypes{type,label}},ancestorData:singleContent(id:$ancestorId)@include(if:$hasAncestor){id,title,type}}"
  }
};
})();

(node as any).hash = "a1921ca607962bf473e7500b25585374";

export default node;
